import PropTypes from "prop-types";
import React from "react";

import { useBankProvider } from "Payments/globalPaymentsStateHooks";

import StaxACHEntry from "./StaxACHEntry";
import WePayACHEntry from "./WePayACHEntry";

export default function ACHEntry(props) {
  const { providerIsStax, providerIsWePay } = useBankProvider();

  // if (!providerIsStax && !providerIsWePay) return null;

  if (providerIsStax) {
    return <StaxACHEntry {...props} />;
  }

  // if (providerIsWePay) {
  return <WePayACHEntry {...props} />;
  // }
}

ACHEntry.propTypes = {
  cardType: PropTypes.string,
  handleEditButtonClick: PropTypes.func,
  last4: PropTypes.string,
};
